import type { FC } from 'react';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import styles from './Home.module.css';
import { Page, PromoDeviceProps, StepType } from '../../../state/types';
import { useState } from '../../../state/store';
import PurchasedDeviceSelector from '../../PurchasedDeviceSelector/PurchasedDeviceSelector';

const Home: FC = () => {
  const { page, dispatch } = useState('page');
  const history = useHistory();

  const handlePhoneSelect = useCallback(
    (promoPhone: PromoDeviceProps) => () => {
      history.push({
        hash: `#${Page.Steps}`,
      });
      dispatch('update', {
        step: StepType.NewDeviceCheck,
        purchasedPhone: promoPhone.alias,
      });
    },
    [history, dispatch]
  );

  if (page !== Page.Home) {
    return null;
  }

  return (
    <div className={`${styles.Home} container flex flex-col text-center`} data-testid="HomePage">
      {/* promoBanner && (
        <section>
          {/*}
        <p className="lead">
          Pre-order now and claim up to an additional €150 on top of the trade-in value when you trade-in an eligible
          smartphone
        </p>
        {*/}
      {
        // <PurchasedDeviceSelector purchasedPhone={null} handlePhoneSelect={handlePhoneSelect} />
      }
      {/*}
        <p className="lead fst-italic">
          * Trade-in Offer available from 17<sup>th</sup> February 2023
        </p>
        {*/}
      {/* 
        <p className="lead">
          Congratulations on the purchase of your new <strong>Samsung Galaxy S23 device</strong>. Claim up to an
          additional €150 on top of the trade-in value when you trade-in an eligible smartphone. Please click on the
          phone model that you purchased to receive your Samsung enhanced trade-in offer.
        </p> 
        </section>
      )}
      {promoBanner && (
        <>
          <img
            src={`${config.publicUrl}/img/samsung_offer.jpg`}
            alt="samsung_phones"
            className={cls(styles.promoBanner)}
          />
          <section>
            <p className="lead mt-4">
              The Samsung Galaxy S23 trade-in promotion has now closed.
              <div>Please revisit this site on the 26th July 2023 to avail of Samsung’s latest trade-in promotion.</div>
            </p>
            <p className="lead"></p>
            <p className="lead">Thank you</p>
          </section>
        </>
      )*/}
      <h3 className="mb-6">
        Congratulations on the recent purchase of your new Samsung Galaxy Fold 5 / Flip 5 smartphone, we hope you are
        enjoying your new device.
      </h3>
      <PurchasedDeviceSelector purchasedPhone={null} handlePhoneSelect={handlePhoneSelect} />
      <section>
        <h3>
          To claim up to an additional €300 on top of the trade-in value of your old device please click on the device
          above that you have recently purchased.
        </h3>
        <p>
          *Terms: Double your enhanced offer when you trade-in an eligible foldable smartphone.
          <br />
          Promotion ends on 5th September 2023. T&C’s Apply.
        </p>
      </section>
      {/*<section>
        <p>&nbsp;</p>
         <p className="text-muted">* Samsung Electronics (Irl) Limited.</p>
        <p className="text-muted">
          Level of reward will vary based on model and condition of trade-in. Not redeemable with any other offer from
          the promoter.
          <br />
          See <a href={`#${Page.TermsAndConditions}`}>terms and conditions</a> for more detail.
        </p> 
      </section> */}
    </div>
  );
};

export default Home;
